import { FFMTheme } from '@fans-fund-me/shared-comm-react-cosmos/themes';
import { AuthProvider } from '@fans-fund-me/shared-common-esm-authentication';
import { CookiesProvider } from '@fans-fund-me/shared-common-esm-cookies';
import { CurrencyProvider } from '@fans-fund-me/shared-common-esm-currency';
import { FingerprintProvider } from '@fingerprint/react';
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.layer.css';
import '@mantine/notifications/styles.layer.css';
import ReactGA from 'react-ga4';
import packageJson from '../package.json';
import { ENDPOINTS as AUTH_ENDPOINTS } from './api/authentication.ts';
import { ENDPOINTS as PROFILE_ENDPOINTS } from './api/profile.ts';
import './App.css';
import { Navigation } from './navigation/Navigation.tsx';

function App() {
  if (import.meta.env.VITE_GA_MEASUREMENT_ID !== undefined) {
    ReactGA.initialize(import.meta.env.VITE_GA_MEASUREMENT_ID);
  }

  if (!window.location.href.includes('localhost')) {
    initializeFaro({
      url: 'https://faro-collector-prod-gb-south-1.grafana.net/collect/e4a2d32dc28c6f90428e630823095bad',
      app: {
        name: 'Fans Fund Me',
        version: packageJson.version,
        environment: import.meta.env.VITE_ENVIRONMENT === 'prod' ? 'production' : 'development',
      },

      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations(),

        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation(),
      ],
    });
  }

  return (
    <MantineProvider defaultColorScheme="dark" theme={FFMTheme}>
      <CookiesProvider product="ffm">
        <CurrencyProvider product="ffm" defaultCurrency="USD">
          <AuthProvider
            product="ffm"
            loginUrl={AUTH_ENDPOINTS.LOGIN}
            logoutUrl={AUTH_ENDPOINTS.LOGOUT}
            userDetailsUrl={PROFILE_ENDPOINTS.USER_DETAILS}
            userDetails={[
              'username',
              'isStripeSetupComplete',
              'notAcceptingPaymentsReasons',
              'currency',
              'privileges',
              'accountType',
            ]}
            storeUserDetails={['username']}
          >
            <FingerprintProvider
              endpoints={'https://fingerprinting.dev.fansfund.me'}
              apiKey={import.meta.env.VITE_FINGERPRINT_PUBLIC_KEY!}
            >
              <Navigation />
            </FingerprintProvider>
          </AuthProvider>
        </CurrencyProvider>
      </CookiesProvider>
    </MantineProvider>
  );
}

export default App;
